import { get } from "lodash";
import Loading from "shared/components/Spin";
import { useMutation, useQuery } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";
import {
  CREATE_ATTACHMENT,
  GENERATE_SUBSCRIPTION_DOCUMENTS,
} from "utils/api/graphql/mutations/attachment";
import {
  DOWNLOAD_DOCUMENT,
  DOWNLOAD_SINGLE_DOCUMENT,
} from "utils/api/graphql/mutations/download-document";
import { SEND_SUBSCRIPTION_ATTACHMENTS } from "utils/api/graphql/mutations/subscription";
import { ATTACHMENTS } from "utils/api/graphql/queries/attachments";
import {
  DOCUMENTS_TYPES,
  INSURANCE_PLAN_ATTACHMENTS_TYPES,
  SUR_COMPLEMENT_WEIGHT,
} from "utils/constants";
import View from "./View";

const Documents = ({ subscription, additionalInfoPercentage, setActive }) => {
  const [downloadSingleDocument] = useMutation(DOWNLOAD_SINGLE_DOCUMENT);
  const [downloadDocuments] = useMutation(DOWNLOAD_DOCUMENT);
  const [generateSubscriptionDocuments] = useMutation(
    GENERATE_SUBSCRIPTION_DOCUMENTS,
    {
      refetchQueries: [
        {
          query: graphql.queries.SUBSCRIPTION,
          awaitRefetchQueries: true,
          variables: { where: { id: get(subscription, "id") } },
        },
      ],
    },
  );
  const [sendSubscriptionAttachments] = useMutation(
    SEND_SUBSCRIPTION_ATTACHMENTS,
    {
      refetchQueries: [
        {
          query: graphql.queries.SUBSCRIPTION,
          awaitRefetchQueries: true,
          variables: { where: { id: get(subscription, "id") } },
        },
      ],
    },
  );
  const upSells = get(
    subscription,
    `project.fields.upsells.${get(subscription, "insurancePlan.id")}`,
    [],
  ).filter(({ weight }) => weight === SUR_COMPLEMENT_WEIGHT);
  const filter = {
    where: {
      OR: [
        ...upSells.map(({ insurancePlan }) => ({
          AND: [
            {
              project: null,
            },
            {
              insurancePlans: {
                id: get(insurancePlan, "id", ""),
              },
            },
          ],
        })),
        {
          AND: [
            {
              project: null,
            },
            {
              insurancePlans: {
                id: get(subscription, "insurancePlan.id", ""),
              },
            },
          ],
        },
        {
          subscription: {
            id: get(subscription, "id"),
          },
        },
        {
          AND: [
            {
              project: {
                id: get(subscription, "project.id"),
              },
            },
            {
              insurancePlans: {
                id: get(subscription, "insurancePlan.id", ""),
              },
            },
          ],
        },
      ],
    },
    isIn: {
      type: [
        ...Object.values(INSURANCE_PLAN_ATTACHMENTS_TYPES),
        DOCUMENTS_TYPES.QUOTE,
      ],
    },
  };
  const { data, loading } = useQuery(ATTACHMENTS, { variables: filter });

  const [addAttachment] = useMutation(CREATE_ATTACHMENT);

  if (loading) return <Loading />;

  return (
    <View
      data={get(data, "attachments.data")}
      additionalInfoPercentage={additionalInfoPercentage}
      setActive={setActive}
      sendAttachments={sendSubscriptionAttachments}
      addAttachment={addAttachment}
      subscription={subscription}
      downloadSingleDocument={downloadSingleDocument}
      downloadDocuments={downloadDocuments}
      generateSubscriptionDocuments={generateSubscriptionDocuments}
    />
  );
};

export default Documents;
